import { getImageAttributes } from '@notino/react-web-utils';

export const getVideoAttrs = (video: string, type: string = 'default') =>
  getImageAttributes(
    {
      src: `https://i.ytimg.com/vi/${video}/${type}.jpg`,
      alt: `${video}`,
      isVideo: true,
    },
    '',
    'video'
  );
